import {compressPhotoFile} from "@mytour/platform";
import {REPORT_MAX_PHOTOS, reportPhotoInputSchema} from "@mytour/shared";
import {type PhotoProcessingState, ReportPhotosField} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";

export const step7Schema = z.object({
  photos: z.array(reportPhotoInputSchema).max(REPORT_MAX_PHOTOS),
});

export type Step7Form = z.infer<typeof step7Schema>;

type Props = {
  hookForm: UseFormReturn<Step7Form>;
  disabled: boolean;
  onPhotoStateChange: (state: PhotoProcessingState) => void;
};

export function Step7({hookForm, disabled, onPhotoStateChange}: Props) {
  return (
    <ReportPhotosField
      control={hookForm.control}
      name="photos"
      getValues={hookForm.getValues}
      trigger={hookForm.trigger}
      error={hookForm.formState.errors.photos}
      disabled={disabled}
      onStateChange={onPhotoStateChange}
      compressPhotoFile={compressPhotoFile}
      labels={{
        sectionLabel: "Photos du compte rendu",
        photoAlt: (index) => `Photo ${index} du compte rendu`,
        galleryLabel: "Ajouter des photos",
        captionLabel: () => "Description de la photo — facultatif",
        counter: (count, max) => `${count}/${max} photos`,
        limitMessage:
          "Vous pouvez ajouter jusqu’à 5 photos par compte rendu. Supprimez une photo pour en ajouter une autre.",
      }}
    />
  );
}
